import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Loader2, Upload } from "lucide-react";

interface PhotoUploadButtonProps {
  uploading: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const PhotoUploadButton = ({ uploading, onChange }: PhotoUploadButtonProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center gap-2">
      <input
        type="file"
        accept="image/*"
        onChange={onChange}
        className="hidden"
        id="avatar-upload"
        disabled={uploading}
      />
      <label htmlFor="avatar-upload">
        <Button 
          type="button" 
          variant="outline" 
          disabled={uploading}
          className="cursor-pointer"
          asChild
        >
          <span>
            {uploading ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                {t('profile.personalInfo.uploading')}
              </>
            ) : (
              <>
                <Upload className="mr-2 h-4 w-4" />
                {t('profile.personalInfo.changePhoto')}
              </>
            )}
          </span>
        </Button>
      </label>
    </div>
  );
};